











import { Component, Prop, Vue } from 'vue-property-decorator';
import swal from "sweetalert2";
import BillboardForm from '../billboard-form/BillboardForm.vue';
import BillboardPreview from '../billboard-preview/BillboardPreview.vue';
import DigitalPost from '@/apiClient/DigitalPost';

declare var mApp: any;

@Component({
    name: 'BillboardCreate',
    components: { BillboardForm, BillboardPreview },
})
export default class BillboardCreate extends Vue {
    digitalPost: DigitalPost;


    data(){
        return{

        }
    }
    created(){
        this.digitalPost = new DigitalPost();
    }

    updated(){
        if(typeof mApp !== 'undefined') mApp.init({})
    }

    async onSubmit(params: any){
        try {
            mApp.block("#billboard-form", {
                overlayColor: "#000000",
                type: "loader",
                state: "success",
                message: `${this.$t('message.billboard_loading_text')}`
            });

           let {status} = await this.digitalPost.create(params);

            if(status === 201){
                mApp.unblock("#billboard-form");
                swal({
                    type: 'success',
                    title: `${this.$t("message.billboard_form_post_create_success_text")}`,
                    showConfirmButton: true,
                    confirmButtonText: `${this.$t("message.billboard_form_post_button_confirm")}`
                }).then( () => {
                    window.location.href = window.origin +'/v3/news-board';
                });
            }
        } catch({response: {message}}){
            mApp.unblock("#billboard-form");
        }
    }

}
